// src/components/compliance/JobBadges.jsx
// Thin wrapper — real implementation in shared/ui/StatusBadge.jsx
// (maps: "complianceJob" / "complianceType", see shared/ui/statusMaps.js).
import PropTypes from "prop-types";
import StatusBadge from "../../shared/ui/StatusBadge";

export function JobStatusBadge({ status }) {
  return <StatusBadge map="complianceJob" status={status} />;
}
JobStatusBadge.propTypes = { status: PropTypes.string.isRequired };

export function JobTypeBadge({ type }) {
  return <StatusBadge map="complianceType" status={type} />;
}
JobTypeBadge.propTypes = { type: PropTypes.string.isRequired };
